import moment from 'moment-timezone';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const TIME_HH_MM_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const AMERICAN_DATE_FORMAT = 'MM/DD/YYYY';

////////////////
// Date Utils
////////////////

export function getTimezone(): string {
    return moment.tz('America/New_York').format('Z');
}

export function getDaysDiff(date1: string, date2: string) {
    return Math.abs(moment(date2).diff(moment(date1), 'days'));
}

export function timestampToDate(ts: number): string {
    return moment.unix(ts / 1000).format(DATE_FORMAT);
}

export function today(): string {
    return moment().utcOffset(getTimezone()).format('YYYY-MM-DD');
}

export function getMomentObj(date: string): moment.Moment {
    return moment(date);
}

export function incrementDateByDays(byDays: number, date: string): string {
    return moment(date).add(byDays, 'days').format(DATE_FORMAT);
}

export function decremenDateByDays(byDays: number, date: string): string {
    return moment(date).subtract(byDays, 'days').format(DATE_FORMAT);
}

export function incrementDateByMonths(byMonths: number, date: string): string {
    return moment(date).add(byMonths, 'months').format(DATE_FORMAT);
}

export function decrementDateByMonths(byMonths: number, date: string): string {
    return moment(date).subtract(byMonths, 'months').format(DATE_FORMAT);
}
export function decrementDateByYears(byYears: number, date: string): string {
    return moment(date).subtract(byYears, 'years').format(DATE_FORMAT);
}
export function getThisWeeksWeekDay(dayInWeek: number): string {
    return moment().utcOffset(getTimezone()).isoWeekday(dayInWeek).format(DATE_FORMAT);
}

export function getLastWeeksWeekDay(dayInWeek: number): string {
    return moment().utcOffset(getTimezone()).subtract(1, 'weeks').isoWeekday(dayInWeek)
        .format(DATE_FORMAT);
}

export function getMonth(date: string): number {
    return moment(date).month();
}
export function getYear(date: string): number {
    return moment(date).year();
}
export function getFirstDayOfMonth(date: string): string {
    return moment(date).startOf('month').format(DATE_FORMAT);
}

export function getFirstDayOfYear(date: string): string {
    return moment(date).startOf('year').format(DATE_FORMAT);
}

export function getLastDayOfYear(date: string): string {
    return moment(date).endOf('year').format(DATE_FORMAT);
}

export function getLastDayOfMonth(date: string): string {
    return moment(date).endOf('month').format(DATE_FORMAT);
}

export function convertDateToAmericanFormat(date: string): string {
    return moment(date, DATE_FORMAT).format(AMERICAN_DATE_FORMAT);
}

export function tConvert(time: any): string {
    if (!time) {
        return '';
    }
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
        time[3] = ' '; // convert seconds to space
    }
    return time.join(''); // return adjusted time or original string
}

export function timeToHoursAndMinutes(time: string): string {
    const date = `1970-01-01 ${time}`;
    return moment(date, DATETIME_FORMAT).format(TIME_HH_MM_FORMAT);
}

export function incrementTimeBySeconds(bySeconds: number, time: string): string {
    const date = `1970-01-01 ${time}`;
    return moment(date).add(bySeconds, 'seconds').format(TIME_FORMAT);
}

export function datetimeFormatToAmericanFormat(datetime: string): string {
    const datetimeSplit = datetime.split(' ');
    return `${convertDateToAmericanFormat(datetimeSplit[0])} ${tConvert(datetimeSplit[1])}`;
}

export function convertDatetimeToTz(datetime: string, tz: string, format: string) {
    return moment.utc(datetime, DATETIME_FORMAT).tz(tz).format(format);
}

////////////////
// Utils
////////////////

String.prototype.hashCode = function hashCode() {
    let hash = 0; let i; let chr;
    if (this.length === 0) return '';
    for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash.toString();
};

function vectorDistance(dx: number, dy: number): number {
    return Math.sqrt(dx * dx + dy * dy);
}

export type LatLong = {
    lat: number;
    long: number;
};

export function locationDistance(location1: LatLong, location2: LatLong): number {
    const dx = location1.lat - location2.lat;
    const dy = location1.long - location2.long;

    return vectorDistance(dx, dy);
}

export function formatPrice(value: number) {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return formatter.format(value);
}

export function formatNumber(value: number, digits: number) {
    const formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: digits });
    return formatter.format(value);
}
